import React from 'react';
import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import { Avatar, Persona, Text, makeStyles, mergeClasses } from '@fluentui/react-components';
import { useId } from '@fluentui/react-hooks';
import { IServiceContact } from './interfaces';
import { labelStyles } from '../../../app/common/styles/CommonStyleObjects';

const useStyles = makeStyles({
  label: {
    display: 'block',
    marginBottom: '8px',
  },
});

interface IServiceContactListProps {
  contacts: Array<IServiceContact>;
  labelText: string;
  horizontal?: boolean;
}

const ServiceContactList = ({
  contacts,
  labelText,
  horizontal,
}: IServiceContactListProps): JSX.Element => {
  const labelClasses = labelStyles();
  const styles = useStyles();
  const labelId = useId('service-contact-list-label');

  const renderLabel = (): JSX.Element => {
    return (
      <div id={labelId} className={mergeClasses(labelClasses.root, styles.label)}>
        {labelText}
      </div>
    );
  };

  if (contacts.length === 0) {
    return (
      <Stack role="group" aria-labelledby={labelId}>
        {renderLabel()}
        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 8 }}>
          <Avatar size={40} color="colorful" name="Not Assigned" />
          <Text size={200}>Not Assigned</Text>
        </Stack>
      </Stack>
    );
  }

  const renderPersona = (person: IServiceContact): JSX.Element => {
    return (
      <Persona
        name={person.isInvalidUser ? `${person.text} (Invalid User)` : person.text}
        secondaryText={person.email}
        avatar={{
          size: 40,
          color: 'colorful',
          badge: person.isInvalidUser ? { status: 'blocked' as const } : undefined,
        }}
        size="medium"
        key={`${labelText}-${person.graphId}`}
        primaryText={{ style: { paddingTop: '10px' } }}
      />
    );
  };

  return (
    <Stack role="group" aria-labelledby={labelId}>
      {renderLabel()}
      <Stack horizontal={horizontal} wrap tokens={{ childrenGap: 3 }}>
        {contacts.map((person: IServiceContact) => {
          return renderPersona(person);
        })}
      </Stack>
    </Stack>
  );
};

export default ServiceContactList;
